export default {"src":"/_next/static/media/delivery-van.4321d1bf.svg","height":500,"width":500};